import React, { useContext, useState } from 'react';
import { RadioGroupField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton, MFBeaconModal } from '../Beacon/BeaconComponents';
import { modalCloseNextModalHandler } from '../Modal/utils';
import styles from './RPSOCRNewFundsModal.css';
import { randomKey } from '../../core/util';

export const termsErrorMsg = `We are unable to proceed with the establishment of the Rollover IRA`;

const RPSOCRNewFundsModal = () => {
  const { appState, formProps, closeNextModal, next } = useContext(FlowContext);
  const { newFundsName } = appState.store.loadedData;

  // Get FundNames if New Funds is chosen
  const newFundNamesArr = newFundsName?.map(({ name }) => name);

  const [agreeToProspectus, setAgreeToProspectus] = useState('');
  const [agreeToPrivacyPolicy, setAgreeToPrivacyPolicy] = useState('');

  const radioYesNoOptions = [
    {
      title: 'Yes',
      value: 'YES'
    },
    {
      title: 'No',
      value: 'NO'
    }
  ];

  const handleProspectus = ({ target: { value } }) => {
    setAgreeToProspectus(value);
    setAgreeToPrivacyPolicy('');
  };

  const handlePrivacyPolicy = ({ target: { value } }) => {
    setAgreeToPrivacyPolicy(value);
  };

  const closeModal = () => {
    return next('rpsNewFundsModal')();
  };

  const disableContinue = agreeToPrivacyPolicy !== 'YES';

  const prospectusTitle = `Do you agree to be bound by the terms of the prospectus 
  for each T.Rowe Price fund in which you are investing, that you have the 
  authority and legal capacity to purchase mutual fund shares, and that you are 
  of legal age in your state?`;

  return (
    <div className="newfund-modal">
      <MFBeaconModal open removeCloseButton>
        <div className="beacon-modal__title">
          Terms and Conditions of Your Selected Funds
        </div>

        <div className="selected-funds">New Funds Selected:</div>
        <div className="fund-name">
          {newFundNamesArr?.map(newFundName => {
            return (
              <div key={randomKey()}>
                <div> {newFundName} </div>
              </div>
            );
          })}
        </div>

        <RadioGroupField
          title={prospectusTitle}
          options={radioYesNoOptions}
          onChange={handleProspectus}
          {...formProps.agreeToProspectus}
          name="agreeToProspectus"
        />

        {agreeToProspectus === 'YES' ? (
          <>
            <div className="modal-special-text">
              Please note, you&apos;ll receive a copy of the prospectus for each
              fund in which you are investing.
            </div>
            <div className="modal-subtext">
              T. Rowe Price Funds&apos; Excessive and Short-Term Trading Policy:
              As stated in the Fund&apos;s prospectus and subject to certain
              exceptions, each T. Rowe Price fund restricts a shareholder&apos;s
              purchases (including through exchanges) into a fund account for a
              period of 30 calendar days after the shareholder has redeemed or
              exchanged out of that same fund account (the &quot;30-Day Purchase
              Block&quot;). Systematic transactions generally are exempt from
              this policy.
            </div>
            <div className="modal-subtext">
              You will be receiving the T. Rowe Price Funds&apos; Privacy Policy
              with your Welcome packet.
            </div>

            <RadioGroupField
              title={
                <div>
                  Do you agree to receive the{' '}
                  <a
                    href="https://home2.troweprice.com/discovery/confluence/display/Compliance/Privacy+Policy"
                    target="_blank"
                    rel="noopener noreferrer">
                    Privacy Policy
                  </a>{' '}
                  after the account is opened?
                </div>
              }
              options={radioYesNoOptions}
              onChange={handlePrivacyPolicy}
              {...formProps.agreeToPrivacyPolicy}
              name="agreeToPrivacyPolicy"
            />
          </>
        ) : (
          <>
            {agreeToProspectus === 'NO' && (
              <div className="terms-error">{termsErrorMsg}</div>
            )}
          </>
        )}

        {agreeToPrivacyPolicy === 'NO' && (
          <div className="terms-error">{termsErrorMsg}</div>
        )}

        <div className="rps-btn-container" slot="action-zone">
          <MFBeaconButton
            variant="primary"
            disabled={disableContinue}
            noButtonMargin
            onClick={() => {
              modalCloseNextModalHandler(closeNextModal);
              closeModal();
            }}
            id="btnOCRNewFundsModalContinue"
            data-name="btnOCRNewFundsModalContinue"
            label="Continue"
          />
        </div>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </div>
  );
};

export default RPSOCRNewFundsModal;
